import { render } from "./AposTagList.vue?vue&type=template&id=25e8652c&scoped=true"
import script from "./AposTagList.vue?vue&type=script&lang=js"
export * from "./AposTagList.vue?vue&type=script&lang=js"

import "./AposTagList.vue?vue&type=style&index=0&id=25e8652c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e8652c"],['__file',"ui/ui/apos/components/AposTagList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25e8652c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25e8652c', __exports__)) {
    api.reload('25e8652c', __exports__)
  }
  
  module.hot.accept("./AposTagList.vue?vue&type=template&id=25e8652c&scoped=true", () => {
    api.rerender('25e8652c', render)
  })

}


export default __exports__